import useApi from 'hooks/useApi'
import { useQuery } from '@tanstack/react-query'

const useGetCarouselSerie = (uuid, enabled = true) => {

  const { apiFetch } = useApi();
  const url = `/carrusels/${uuid}/series?hasBody=false`

  const getCarousel = () => {
    if (!uuid) return []
    
    return apiFetch({ url })
      .then( res => {
        const data = res.data.contents.map((serie) => (
          { ...serie, to:`series/${serie.uuid}` }
        ))
        return data
      })
  }

  const options = {
    staleTime: 60000 * 30, // 30 min
    placeholderData: [],
    enabled
  }

  return useQuery(['serie', uuid, 'lang'], getCarousel, options)
}

export default useGetCarouselSerie
